import {
	CUPONERA_SEATS_BEGIN,
	CUPONERA_SEATS_FAILURE,
	CUPONERA_SEATS_SUCCESS,
	SELECT_CUPONERA,
} from './constants';

import CommonService from '../../../services/commonService';
import axios from 'axios';

export function fetchCuponeraSeats(args = {}) {
	return dispatch => {
		dispatch({
			type: CUPONERA_SEATS_BEGIN,
		});

		const promise = new Promise((resolve, reject) => {
			const doRequest = axios.get(args.url, {
				headers: CommonService.getHeaders(),
			});
			doRequest.then(
				res => {
					dispatch({
						type: CUPONERA_SEATS_SUCCESS,
						data: res && res.data && res.data.data && res.data.data.data || {},
						// data: res.data.data.data || {},
						// data: res.data.data.data || {},
						// data: res?.data?.data?.data || {},

					});
					resolve(res);
				},
				err => {
					dispatch({
						type: CUPONERA_SEATS_FAILURE,
						data: { error: err },
					});
					reject(err.response);
				},
			);
		});

		return promise;
	};
}

export function setSelectCuponera(cuponera) {
	return dispatch => {
		dispatch({
			type: SELECT_CUPONERA,
			data: cuponera,
		});
	};
}
export function setCuponeraSeats(cuponera) {
	return dispatch => {
		dispatch({
			type: CUPONERA_SEATS_SUCCESS,
			data: cuponera,
		});
	};
}

export const reducer = (state, action) => {
	switch (action.type) {
		case CUPONERA_SEATS_BEGIN:
			return { ...state, cuponeraSeats: {}, cuponeraLoading: true };
		case CUPONERA_SEATS_SUCCESS:
			return { ...state, cuponeraSeats: action.data, cuponeraLoading: false };
		case CUPONERA_SEATS_FAILURE:
			return { ...state, cuponeraSeats: {}, cuponeraLoading: false };
		case SELECT_CUPONERA:
			return { ...state, selectedCuponera: action.data };
		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/features/cuponera/redux/cuponera-seats.js